// ./src/store/slices/navigationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { URLS } from '../../utils/urls';

interface NavigationState {
    currentPage: string;
    lastVisitedDesignPage: string | null; // Tracks the last visited design page
}

const initialState: NavigationState = {
    currentPage: '',
    lastVisitedDesignPage: null,
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        resetNavigationState(state) {
            state.currentPage = '';
            state.lastVisitedDesignPage = null;
        },
        setCurrentPage(state, action: PayloadAction<string>) {
            state.currentPage = action.payload;

            const designPages = [
                URLS.SELECT_DESIGN,
                URLS.EDIT_CARD,
                URLS.ENVELOPE,
                URLS.BACKGROUND,
            ];

            // Update lastVisitedDesignPage only for design pages
            const isDesignPage = designPages.some((path) => action.payload.startsWith(path));
            
            if (isDesignPage) {
                state.lastVisitedDesignPage = action.payload;
            }
        },
    },
});

export const { setCurrentPage, resetNavigationState } = navigationSlice.actions;
export default navigationSlice.reducer;
